import {entities} from '../../util/uiconstants';

export const findEntityUidInsideTree = (
	state,
	targetEntityUid,
	allowedEntityIds = [entities.WCGW, entities.Control, entities.ItSoApplication]
) => {
	for (const key of Object.keys(state)) {
		const roData = state[key];
		for (let fsroTreeListIdx = 0; fsroTreeListIdx < roData.fsroTreeList.length; fsroTreeListIdx++) {
			const treeItem = roData.fsroTreeList[fsroTreeListIdx];

			if (treeItem.entityUId === targetEntityUid.toString() && allowedEntityIds.includes(treeItem.entityId)) {
				return {
					main: key,
					fsroTreeList: fsroTreeListIdx
				};
			}

			for (const itemChildKey of Object.keys(treeItem.children)) {
				const itemChild = treeItem.children[itemChildKey];
				const {entityId, entityUId} = itemChild;
				if (entityUId === targetEntityUid.toString() && allowedEntityIds.includes(entityId)) {
					return {
						main: key,
						fsroTreeList: fsroTreeListIdx,
						itemChild: itemChildKey
					};
				}
			}
		}
	}
};
